import { Checkbox, Group, Input } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useCanAccess } from '@mygpt/app';
import { getI18nFieldValue } from '@mygpt/app/language';

import { useWidgetFormContext } from '@/components/Widget/Embed/form-context';
import { useWidgetForm } from '@/hooks/useWidgetForm';

import { SettingCard } from './SettingCard';

/** 引导文案：仅 /bot 纯聊天分享页生效 */
export const ShareGuide = () => {
  const { t, i18n } = useTranslation();
  const { form } = useWidgetFormContext();
  const { onOverrideChangeForForm } = useWidgetForm();
  const canAccessWidgetCustomization = useCanAccess('enable_widget_customization');

  return (
    <SettingCard title={t('widget.setting.groups.card_guide_text')}>
      <Group justify="space-between">
        <Checkbox
          disabled={!canAccessWidgetCustomization}
          label={t('widget.setting.chatbot.chat_guide_text_label')}
          checked={form.values.chatbot.chatGuideText?.checked}
          {...form.getInputProps('chatbot.chatGuideText.checked')}
          onChange={onOverrideChangeForForm('chatbot.chatGuideText.checked')}
        />
        <section className="w-[200px]">
          <Input
            disabled={!form.values.chatbot.chatGuideText?.checked}
            autoComplete="off"
            value={getI18nFieldValue(form.values.chatbot.chatGuideText?.value, i18n.language)}
            onChange={(e) => {
              const newVal = e.currentTarget.value;
              // 清空：整体清空，下次保存不再触发翻译，分享页回退到默认提示
              if (!newVal) {
                form.setFieldValue('chatbot.chatGuideText.value', '');
                return;
              }
              const current = form.values.chatbot.chatGuideText?.value;
              const nextDict =
                current && typeof current === 'object'
                  ? { ...current, [i18n.language]: newVal }
                  : { [i18n.language]: newVal };
              form.setFieldValue('chatbot.chatGuideText.value', nextDict);
            }}
            onBlur={onOverrideChangeForForm('chatbot.chatGuideText.value')}
          />
        </section>
      </Group>
    </SettingCard>
  );
};
